import { render, staticRenderFns } from "./WorkflowHistoryDialog.vue?vue&type=template&id=6c7dbbb3&scoped=true&"
import script from "./WorkflowHistoryDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowHistoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowHistoryDialog.vue?vue&type=style&index=0&id=6c7dbbb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7dbbb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VDialog,VFlex,VIcon,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
